export const COHORT = 'COHORT';

export enum Cohorts {
  INVESTORS = 'INVESTORS',
  HOME_OWNERS = 'HOME_OWNERS',
  TAILORED = 'TAILORED',
}
